(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvRecycleBin', drvRecycleBin);

    /**
     * @ngdoc directive
     * @name drvRecycleBin
     *
     * @description
     * Show a recycle bin for deleted objects
     *
     */
    function drvRecycleBin() {
        return {
            templateUrl: 'app/item/recycle-bin.tmpl.html',
            scope: {},
            controller: drvRecycleBinCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
            }
        };
    }

    drvRecycleBinCtrl.$inject = [
        '$q',
        '$scope',
        '$timeout',
        '$location',
        'ItemService',
        'DialogService',
        'SystemService',
        'EntitiesService',
        'Task',
        'PromiseLatest'];

    function drvRecycleBinCtrl(
        $q,
        $scope,
        $timeout,
        $location,
        ItemService,
        DialogService,
        SystemService,
        EntitiesService,
        Task,
        PromiseLatest) {

        /* jshint validthis:true */
        var drvCtrl = this;

        drvCtrl.parentItems = getDefaultParentItems();
        drvCtrl.items = [];
        drvCtrl.itemCount = 0;
        drvCtrl.currentPage = 1;
        drvCtrl.pageSize = 10;
        drvCtrl.loading = false;
        drvCtrl.error = '';
        drvCtrl.users = [];
        drvCtrl.updateList = updateList;
        drvCtrl.tabChanged = tabChanged;
        drvCtrl.restore = restore;
        drvCtrl.canRestore = canRestore;
        drvCtrl.deleteItem = deleteItem;
        drvCtrl.restoreSelectedItems = restoreSelectedItems;
        drvCtrl.permanentDeleteSelectedItems = permanentDeleteSelectedItems;
        drvCtrl.getItemTypeLabel = getItemTypeLabel;
        drvCtrl.getLabel = getLabel;
        drvCtrl.parentItemClick = parentItemClick;
        drvCtrl.goDownLevel = goDownLevel;
        drvCtrl.goUpLevel = goUpLevel;
        drvCtrl.viewItem = viewItem;
        drvCtrl.searchDescription = '';
        drvCtrl.searchRecordType = '';
        drvCtrl.searchDeletionType = ['Logical'];
        drvCtrl.searchUser = null;
        drvCtrl.userEntityTemplateName = 'User';
        drvCtrl.recordTypes = [
            { value: 'DashboardSetting', description: 'Dashboard Panel', iconUsage: 'home' },
            { value: 'DocumentTemplate', description: 'Document Template', iconUsage: 'document template' },
            { value: 'Email', description: 'Email', iconUsage: 'email' },
            { value: 'EmailAddressCache', description: 'Email Address Cache', iconUsage: 'email address cache' },
            { value: 'EmailTemplate', description: 'Email Template', iconUsage: 'email template' },
            { value: 'Entity', description: 'Entity', iconUsage: 'entity' },
            { value: 'EntityTemplate', description: 'Entity Template', iconUsage: 'entity template' },
            { value: 'File', description: 'File', iconUsage: 'file' },
            { value: 'Note', description: 'Note', iconUsage: 'note' },
            { value: 'SMS', description: 'SMS', iconUsage: 'sms' },
            { value: 'SMSTemplate', description: 'SMS Template', iconUsage: 'sms template' },
            { value: 'Task', description: 'Task', iconUsage: 'task' },
            { value: 'WorkflowDefinition', description: 'Workflow Definition', iconUsage: 'workflow' },
            { value: 'WorkflowInstance', description: 'Workflow Instance', iconUsage: 'history' }
        ];

        drvCtrl.currentTabPage = 'logical';
        drvCtrl.parentId = null;
        drvCtrl.logicalDeletedTypes = ['Logical'];
        drvCtrl.childLogicalDeletedTypes = ['Logical', 'LogicalCascade'];
        drvCtrl.permanentDeletedTypes = ['Permanent'];
        drvCtrl.childPermanentDeletedTypes = ['Permenant', 'PermanentCascade'];

        var updateListPromise = new PromiseLatest();

        activate();

        function activate() {
            drvCtrl.searchDelay = SystemService.getSearchDelay();
            updateList();
            loadUsers();

            function searchVariableChanged(newVal, oldVal) {
                if (newVal != oldVal) {
                    updateList();
                }
            }

            $scope.$watch('drvCtrl.parentId', searchVariableChanged);
            $scope.$watch('drvCtrl.itemType', searchVariableChanged);
            $scope.$watch('drvCtrl.searchRecordType', searchVariableChanged);
            $scope.$watch('drvCtrl.searchDescription', searchVariableChanged);
            $scope.$watch('drvCtrl.searchUser', searchVariableChanged);
        }

        function tabChanged() {
            drvCtrl.parentId = null;
            drvCtrl.parentItems = getDefaultParentItems();
            drvCtrl.updateList(1);
        }

        /**
         * Update the data for the item list.
         *
         * @param {number} delay - Optional. A delay, in milliseconds, for debounce-like functionality.
         *   data will not be updated until the delay elapses, unless a subsequent call with a shorter
         *   remaining delay is made.
         */
        function updateList(delay) {
            if (!_.isNil(updateList.timeout)) {
                $timeout.cancel(updateList.timeout);
                updateList.timeout = null;
            }

            if (_.isNil(delay) || delay === 0) {
                getItems();
            } else {
                $timeout(getItems, delay);
            }

            function getItems() {
                var searchDeletionType = drvCtrl.logicalDeletedTypes;
                if (drvCtrl.currentTabPage === 'permanent') {
                    if (!_.isNil(drvCtrl.parentId)) {
                        searchDeletionType = drvCtrl.childPermanentDeletedTypes;
                    } else {
                        searchDeletionType = drvCtrl.permanentDeletedTypes;
                    }
                } else if (!_.isNil(drvCtrl.parentId)) {
                    searchDeletionType = drvCtrl.childLogicalDeletedTypes;
                }

                drvCtrl.loading = true;

                updateListPromise.latestOnly(ItemService.getItemsByParent(drvCtrl.parentId, {
                    recordType: drvCtrl.searchRecordType,
                    deletionTypes: searchDeletionType,
                    description: drvCtrl.searchDescription,
                    userId: drvCtrl.searchUser,
                    tagIds: drvCtrl.searchTagIds,
                    pageNumber: drvCtrl.currentPage,
                    pageSize: drvCtrl.pageSize
                }))
                    .then(getItemsOk, getItemsError)
                    .finally(function () { drvCtrl.loading = false; });
            }

            function getItemsOk(items) {
                _.forEach(items.Items, function (item) {
                    formatItemForView(item);
                });

                _.forEach(items.Items, function (item) {
                    _.forEach(item.Owners, function (itemOwner) {
                        formatItemForView(itemOwner, true);
                    });
                });

                drvCtrl.items = items.Items;
                drvCtrl.itemCount = items.ItemCount;

                if (angular.isFunction(drvCtrl.listUpdated)) {
                    drvCtrl.listUpdated();
                }
            }

            function getItemsError(response) {
                drvCtrl.error = response;
            }

            /**
             * Format an "Item" for viewing. Some properties may be added, others may be modified.
             *
             * @param {object} item - The item to be formatted.
             * @param {bool} includeTypePrefix - True if item.Description should be prefixed with
             *   the item type / entity template name.
             */
            function formatItemForView(item, includeTypePrefix) {
                item.iconUsage = item.Type;
                item.icon = '';

                if (item.Type === 'SMS') {
                    item.iconUsage = '';
                    item.icon = 'sms-sent';
                } else if (item.Type === 'Email') {
                    if (item.EmailStatus === 'Sent') {
                        item.iconUsage = 'email-sent';
                    } else if (item.EmailStatus === 'Received') {
                        item.iconUsage = 'email-received';
                    } else if (item.EmailStatus === 'Draft') {
                        item.iconUsage = 'email-draft';
                    }
                } else if (item.Type === 'Entity') {
                    item.iconUsage = '';
                    item.icon = item.EntityTemplateIcon;
                    item.iconColour = item.EntityTemplateIconColour;
                } else if (item.Type === 'EntityTemplate') {
                    item.iconUsage = 'entity template';
                } else if (item.Type === 'EmailAddressCache') {
                    item.iconUsage = 'email address cache';
                } else if (item.Type === 'DocumentTemplate') {
                    item.iconUsage = 'document template';
                } else if (item.Type === 'EmailTemplate') {
                    item.iconUsage = 'email template';
                } else if (item.Type === 'SMSTemplate') {
                    item.iconUsage = 'sms template';
                } else if (item.Type === 'DashboardSetting') {
                    item.iconUsage = 'home';
                } else if (item.Type === 'WorkflowDefinition') {
                    item.iconUsage = 'workflow';
                } else if (item.Type === 'WorkflowInstance') {
                    item.iconUsage = 'history';
                }

                if (includeTypePrefix) {
                    if (item.EntityTemplateName) {
                        item.Description = item.EntityTemplateName + ' - ' + item.Description;
                    } else {
                        item.Description = item.Type + ' - ' + item.Description;
                    }
                }
            }

        }

        /**
         * Load all users.
         */
        function loadUsers() {
            return EntitiesService.query({ entityType: 'User' })
                .then(getUsersOk, getUsersError);

            function getUsersOk(data) {
                drvCtrl.users = data.Entities;
                
                if (data.Entities.length > 0) {
                    drvCtrl.userEntityTemplateName = data.Entities[0].EntityTemplate.Name;
                }
            }

            function getUsersError(response) {
                DialogService.error('Error fetching Users', response);
            }
        }

        function restore(item) {
            DialogService.confirm('Restore the ' + item.Type + ' \'' + item.Description + '\'?', drvCtrl.getLabel() + ' restore confirm')
                .then(restoreConfirmed);

            function restoreConfirmed() {
                drvCtrl.loading = true;

                ItemService.restoreItem(item.Id)
                    .then(restoreItemOk, restoreItemError)
                    .finally(function () { drvCtrl.loading = false; });
            }
        }

        function restoreSelectedItems() {
            var itemIds = getSelectedItemIds();

            if (ensureItemSelection()) {
                DialogService.confirm('Restore the ' + itemIds.length + ' ' + drvCtrl.getLabel(itemIds.length > 1) + '?', drvCtrl.getLabel() + ' restore confirm')
                    .then(restoreConfirmed);
            }

            function restoreConfirmed() {
                drvCtrl.loading = true;

                ItemService.restoreItems(itemIds)
                    .then(restoreItemOk, restoreItemError)
                    .finally(function () { drvCtrl.loading = false; });
            }
        }

        function restoreItemOk() {
            drvCtrl.updateList();
        }

        function restoreItemError(response) {
            drvCtrl.error = response;
        }

        function permanentDeleteSelectedItems() {
            var itemIds = getSelectedItemIds();

            if (ensureItemSelection()) {
                DialogService.confirm('Permanently delete the ' + itemIds.length + ' ' + drvCtrl.getLabel(itemIds.length > 1) + '?', drvCtrl.getLabel() + ' delete confirm')
                    .then(deleteConfirmed);
            }

            function deleteConfirmed() {
                DialogService.show({
                    locals: { itemIds: itemIds },
                    controller: 'ViewItemUsageDialog',
                    controllerAs: 'vm',
                    templateUrl: 'app/controls/dialog/view-item-usage-dialog.tmpl.html',
                    size: 'xl'
                });
            }
        }

        function deletionTypeChanged() {
            if (_.isNil(drvCtrl.searchDeletionType) || drvCtrl.searchDeletionType.length === 0) {
                drvCtrl.searchDeletionType = ['Logical'];
            }
        }

        function getItemTypeLabel(item) {
            var result = item.Type;

            switch (item.Type) {
                case 'DocumentTemplate':
                    result = 'Document Template';
                    break;
                case 'EmailAddressCache':
                    result = 'Email Address Cache';
                    break;
                case 'EmailTemplate':
                    result = 'Email Template';
                    break;
                case 'Entity':
                    result = !_.isNil(item.EntityTemplateName) ? item.EntityTemplateName : 'Entity';
                    break;
                case 'EntityTemplate':
                    result = 'Entity Template';
                    break;
                case 'SMSTemplate':
                    result = 'SMS Template';
                    break;
                case 'DashboardSetting':
                    result = 'Dashboard Panel';
                    break;
                case 'WorkflowDefinition':
                    result = 'Workflow Definition';
                    break;
                case 'WorkflowInstance':
                    result = 'Workflow Instance';
                    break;
                default:
                    break;
            }

            return result;
        }

        /**
         * Get the Id's of the items selected in the view.
         *
         * @return {array} - Array of {number}
         */
        function getSelectedItemIds() {
            return _.chain(drvCtrl.items).filter('Selected').map('Id').value();
        }

        /**
         * Ensure at least one Item is selected.
         * Displays a dialog 'No Items were selected' if no Items are selected.
         *
         * @return {bool} true if at least one Item is selected, else false
         */
        function ensureItemSelection() {
            if (getSelectedItemIds().length === 0) {
                DialogService.alert('No ' + drvCtrl.getLabel(true) + ' were selected.');
                return false;
            } else {
                return true;
            }
        }

        /**
         * Get the items label
         *
         * @returns {string}
         */
        function getLabel(plural) {
            var result = '';

            if (plural === true && !_.isNil(drvCtrl.itemPluralLabel) && drvCtrl.itemPluralLabel !== '') {
                result = drvCtrl.itemPluralLabel;
            } else if (!_.isNil(drvCtrl.itemLabel) && drvCtrl.itemLabel !== '') {
                result = drvCtrl.itemLabel;
            } else {
                if (plural === true) {
                    result = 'Objects';
                } else {
                    result = 'Object';
                }
            }

            return result;
        }

        function getDefaultParentItems() {
            return [{ Description: 'All', Id: null }];
        }

        function parentItemClick(index) {
            if (drvCtrl.parentItems.length - 1 > index) {
                drvCtrl.parentItems = drvCtrl.parentItems.slice(0, index + 1);
            }

            drvCtrl.parentId = drvCtrl.parentItems[index].Id;
        }

        function goDownLevel(item) {
            drvCtrl.parentItems.push(_.cloneDeep(item));
            drvCtrl.parentId = item.Id;
        }

        function goUpLevel() {
            drvCtrl.parentItems = drvCtrl.parentItems.slice(0, drvCtrl.parentItems.length - 1);
            drvCtrl.parentId = drvCtrl.parentItems[drvCtrl.parentItems.length - 1].Id;
        }

        function canRestore(item) {
            return !_.isNil(item) && (item.DeletionType === 'Logical');
        }

        function viewItem(item) {
            DialogService.show({
                locals: { item: item },
                controller: 'ViewItemDialog',
                controllerAs: 'vm',
                templateUrl: 'app/controls/dialog/view-item-dialog.tmpl.html'
            });
        }

        function deleteItem(item) {
            DialogService.show({
                locals: { itemIds: [item.Id] },
                controller: 'ViewItemUsageDialog',
                controllerAs: 'vm',
                templateUrl: 'app/controls/dialog/view-item-usage-dialog.tmpl.html',
                size: 'xl'
            }).then(updateList, updateList);
        }
    }
})();
